import {
  EMAIL_SELECTOR,
  revealEmail,
  revealEmails,
} from '~/utils/emailObfuscation'

// Replaces the placeholders created by obfuscateEmails with regular mailto links in the page.
// Content inside shadow roots (CustomHtml.vue) is handled by the component itself.
export default defineNuxtPlugin((nuxtApp) => {
  let observer: MutationObserver | undefined

  // Only after hydration, so Vue finds the server-rendered HTML unchanged. From then on,
  // content inserted later is handled too (page navigation, accordions, "load more").
  nuxtApp.hook('app:suspense:resolve', () => {
    revealEmails(document.body)
    if (observer) return

    observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        // Existing link patched to a new token, e.g. a NuxtLink in the live preview
        if (mutation.type === 'attributes') {
          const el = mutation.target as Element
          if (el.matches(EMAIL_SELECTOR)) revealEmail(el)
          continue
        }
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) revealEmails(node)
        })
      }
    })
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href', 'data-email'],
    })
  })
})
